import { render, staticRenderFns } from "./TabUserGeneral.vue?vue&type=template&id=ecc0462e&scoped=true&"
import script from "./TabUserGeneral.vue?vue&type=script&lang=js&"
export * from "./TabUserGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc0462e",
  null
  
)

export default component.exports